module.exports = __webpack_public_path__ + "img/detail10.3c5e059d.png";